export const MACHINES = [
  { id: "m1", name: "Maachine 1", color: "#3B82F6" },
  { id: "m2", name: "Maachine 2", color: "#8B5CF6" },
  { id: "m3", name: "Maachine 3", color: "#EC4899" },
  { id: "m4", name: "Maachine 4", color: "#F59E0B" },
  { id: "m5", name: "Maachine 5", color: "#10B981" },
  { id: "m6", name: "Maachine 6", color: "#EF4444" },
];

export const BRANCHES = [
  { id: "b1", name: "Sucursal 1 ", address: "Zona Industrial, Lote 5", icon: "🏭", color: "#6366F1" },
  { id: "b2", name: "Sucursal 2", address: "Av. Bolívar #120", icon: "🏢", color: "#0EA5E9" },
  { id: "b3", name: "Sucursal 3", address: "Calle 8, Local 3B", icon: "🏢", color: "#F97316" },
  { id: "b4", name: "Sucursal 4", address: "Centro Comercial Plaza", icon: "🔧", color: "#14B8A6" },
];

export const DAYS_FULL = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];
export const DAYS_SHORT = ["D", "L", "M", "M", "J", "V", "S"];

export const MONTHS = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];
export const MONTHS_SHORT = ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"];
